"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const plc_1 = require("../../../plc");
const plcInput_1 = require("../plcInput");
let PlcCheckboxComponent = class PlcCheckboxComponent extends plcInput_1.PlcInput {
    constructor(inaxPlc) {
        super(inaxPlc);
        this.displayMessage = '';
        /* SPECIFIC INPUTS */
        this.trueValue = 'true';
        this.falseValue = 'false';
        this.trueValueMessage = 'Start';
        this.falseValueMessage = 'Stop';
    }
    get Value() {
        return (this._value === this.trueValue) ? 'checked' : '';
    }
    set Value(v) {
    }
    ngOnInit() {
        this.initializeDefaultProperties();
        this.initialize();
        this.subscribe();
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
    initialize() {
    }
    /**
     * updates the current value
     * - if the value equals trueValue, trueValueMessage is displayed in the label
     * - in all other cases, falseValueMessage is displayed
     * @param value     the value to set
     */
    updateValue(value) {
        this._value = value;
        this.displayMessage = (value === this.trueValue) ? this.trueValueMessage : this.falseValueMessage;
    }
    /**
     * writes the other specified value (different values are treated like falseValue)
     * if the write operation does return false, the checkbox is set to the current
     * Value (before the switch) so it does always display the actual value
     */
    switchValue() {
        let val = (this._value === this.trueValue) ? this.falseValue : this.trueValue;
        if (this.write(val) !== true) {
            this.checkbox.nativeElement.checked = this.Value;
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcCheckboxComponent.prototype, "trueValue", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcCheckboxComponent.prototype, "falseValue", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcCheckboxComponent.prototype, "trueValueMessage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcCheckboxComponent.prototype, "falseValueMessage", void 0);
__decorate([
    core_1.ViewChild('plccheckbox'),
    __metadata("design:type", Object)
], PlcCheckboxComponent.prototype, "checkbox", void 0);
PlcCheckboxComponent = __decorate([
    core_1.Component(Object.assign({
        selector: 'plc-checkbox',
        templateUrl: './@inax/plcUi/src/plcCheckbox/plc-checkbox.component.html',
        styleUrls: ['./@inax/plcUi/src/plcCheckbox/plc-checkbox.component.css']
    }, plcInput_1.PlcInput.metaData)),
    __metadata("design:paramtypes", [plc_1.InaxPlcService])
], PlcCheckboxComponent);
exports.PlcCheckboxComponent = PlcCheckboxComponent;
